<script setup lang="ts">
import MAudioPlayer from ".";
</script>
<template>
  <div class="flex flex-col gap-3">
    <m-audio-player
      model-value="https://www.learningcontainer.com/wp-content/uploads/2020/02/Kalimba.mp3"
    />
  </div>
</template>
